import script from "./SubscriptionsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionsTable.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionsTable.vue?vue&type=style&index=0&id=fc966156&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc966156"]])

export default __exports__